<template>
    <FormatSelect
        :formats="formatItems"
        :actions="plainActions"
        :value="innerValue"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        :loading="loading"
        :dense="dense"
        :outlined="outlined"
        :filled="filled"
        :hide-details="hideDetails"
        :show-unit-option="false"
        :show-custom-option="false"
        :show-create-option="false"
        kind-first
        @input="onInput"
        @keydown="$emit('keydown', $event)"
        @blur="$emit('blur')"
    />
</template>

<script>
import FormatSelect from "@/components/common/format-select.vue";

const SALE_FORMAT_PREFIX = "sf:";

/**
 * Unit selector for quantity inputs, derived from FormatSelect.
 * Kind-first flow: piece / weight / volume / format, then the detail
 * (chips or container cascade). Values are plain unit strings or
 * "sf:<format_id>".
 */
export default {
    name: "QuantityUnitSelect",
    components: { FormatSelect },
    props: {
        value: {
            type: String,
            default: null,
        },
        // [{ text, value, format }] as built by $utils.getComponentUnitOptions.
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        filled: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: true,
        },
    },
    computed: {
        formatItems() {
            return this.options
                .filter((option) => option.format)
                .map((option) => option.format);
        },
        plainActions() {
            return this.options
                .filter((option) => !option.format)
                .map((option) => ({ text: option.text, value: option.value }));
        },
        innerValue() {
            if (
                typeof this.value === "string"
                && this.value.startsWith(SALE_FORMAT_PREFIX)
            ) {
                const id = Number(this.value.slice(SALE_FORMAT_PREFIX.length));
                return Number.isNaN(id) ? null : id;
            }
            return this.value;
        },
    },
    methods: {
        onInput(selected) {
            if (selected == null || selected === "") {
                return;
            }
            const plain = this.options.find(
                (option) => !option.format && option.value === selected,
            );
            if (plain) {
                this.$emit("input", plain.value);
                return;
            }
            const formatted = this.options.find(
                (option) => option.format && option.format.id == selected,
            );
            if (formatted) {
                this.$emit("input", formatted.value);
            }
        },
    },
};
</script>
